import axios from 'axios';
import { url, setHeaders } from '../../api';
import { toast } from 'react-toastify';

export const getPatient = (id)=> {
    return (dispatch, getState)=> {
        axios
        .get(`${url}/getPatient/${id}`, setHeaders())
        .then(patient=> {

            dispatch({
                type: 'GET_PATIENT',
                patient
            })
        })
        .catch(error=> {
            console.log(error.response)

            toast.error(error.response?.data, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        })
    }
}

export const updatePatient = (updatedPatient, id)=> {
    return (dispatch)=> {
        axios
        .put(`${url}/updatePatient/${id}`, updatedPatient, setHeaders())
        .then(patient=> {

            dispatch({
                type: 'UPDATE_PATIENT',
                patient
            })
        })
        .catch(error=> {
            console.log(error.response)

            toast.error(error.response?.data, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        })
    }
}

// export const addPatientInfo = (patientData)=> {
//     return (dispatch, getState)=> {
//         axios
//         .post(`${url}/addPatient`, patientData)
//         .then(patientData=> {

//             dispatch({
//                 type: 'ADD_PATIENT',
//                 patientData
//             })
//         })
//         .catch(error=> {
//             console.log(error.response)

//             toast.error(error.response?.data, {
//                 position: toast.POSITION.BOTTOM_RIGHT
//             });
//         })
//     }
// }

// return (dispatch, getState)=> {
//     axios
//     .post(`${url}/addPatient`, patientData)
//     .then(securetoken=> {
//         localStorage.setItem('securetoken', securetoken.data)

//         dispatch({
//             type: 'ADD_PATIENT',
//             securetoken: securetoken.data
//         })
//     })
//     .catch(error=> {
//         console.log(error.response)

//         toast.error(error.response?.data, {
//             position: toast.POSITION.BOTTOM_RIGHT
//         });
//     })
// }
// }

// export const createUser = (user)=> {
//     return (dispatch)=> {
//         axios
//         .post(`${url}/createUser`, user)
//         .then(securetoken=> {
//             localStorage.setItem('securetoken', securetoken.data)

//             dispatch({
//                 type: 'CREATE_USER',
//                 securetoken: securetoken.data
//             })
//         })
//         .catch(error=> {
//             console.log(error.response)

//             // toast.error(error.response?.data) {
//             //     position: toast.POSITION.BOTTOM_RIGHT
//             // }
//         })
//     }
// }

export const loadUser = ()=> {
    return (dispatch, getState)=> {

        const secureToken = getState().auth.secureToken

        if(secureToken){
            dispatch({
                type: "USER_LOADED",
                secureToken
            })
        } else return null
    }
}